

export default [
    {
        path: '/technologicalProcess',
        name: 'technologicalProcess',
        component: () => import(/* webpackChunkName: "technologicalProcess" */'@/customized/technologicalProcess/index'),
    },
    {
        path: '/electronicFence',
        name: 'electronicFence',
        component: () => import(/* webpackChunkName: "electronicFence" */'@/customized/electronicFence/index'),
    },
    {
        path: '/map',
        name: 'map',
        component: () => import(/* webpackChunkName: "electronicFence" */'@/customized/map/index'),
    }
]